var React = require('react');

function Node (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"node"},[React.createElement("rect",{"id":"bot","x":"0","y":"0","width":"24","height":"24","key":0}),React.createElement("rect",{"id":"Rectangle-64","stroke":"#333333","fill":"#FFFFFF","strokeLinecap":"round","strokeLinejoin":"round","x":"2","y":"9","width":"19.6900005","height":"6.86649724","rx":"3.43324862","key":1})])));
}

Node.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Node;

Node.default = Node;
